(function() {

  'use strict';

  function Encomenda($rootScope, $q, EncomendaResource, AreaResource) {

    var Encomenda = {};

    var encomenda = {};

    Encomenda.setEncomenda = function(novaEncomenda) {
      encomenda = novaEncomenda;
    };

    Encomenda.getEncomenda = function() {
      return encomenda;
    };

    Encomenda.criar = function(pedido, item, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.save({
          orderId: pedido.id
        }, item).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        }).
      catch(function(err) {
        deferred.reject(err);
        return cb(err);
      }.bind(this));

      return deferred.promise;
    };

    Encomenda.atualizar = function(pedido, item, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.save({
          orderId: pedido.id,
          itemId: item.id
        }, item).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        }).
      catch(function(err) {
        deferred.reject(err);
        return cb(err);
      }.bind(this));

      return deferred.promise;
    };

    Encomenda.remover = function(pedido, item, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.cancelarEncomendas({
          pedidoId: pedido.id
        }, {
          codigosRastreamento: [item.codigoRastreamento],
          motivo: "Pedido cancelado a pedido do cliente"
        }).$promise
        .then(function(data) {
          // Processa a resposta de cancelamento
          var resultado = {
            sucesso: data.status === 'SUCESSO',
            parcial: data.status === 'PARCIAL',
            falha: data.status === 'FALHA',
            mensagem: data.mensagem,
            remessasCanceladas: data.remessasCanceladas || [],
            erros: data.erros || []
          };
          deferred.resolve(resultado);
          return cb(resultado);
        }).
      catch(function(err) {
        // Extrai a mensagem de erro do backend
        var mensagemErro = 'Erro ao cancelar encomenda';
        if (err.data && err.data.mensagem) {
          mensagemErro = err.data.mensagem;
        } else if (err.data && err.data.message) {
          mensagemErro = err.data.message;
        } else if (err.message) {
          mensagemErro = err.message;
        }

        var resultado = {
          sucesso: false,
          mensagem: mensagemErro,
          erros: []
        };
        deferred.reject(resultado);
        return cb(resultado);
      }.bind(this));

      return deferred.promise;
    };

    Encomenda.removerTodasSelecionadas = function(items, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      // Extrai os códigos de rastreamento dos itens selecionados
      var codigosRastreamento = [];
      var pedidoId = null;

      items.forEach(function(item) {
        if (item.codigoRastreamento) {
          codigosRastreamento.push(item.codigoRastreamento);
        }
        if (!pedidoId && item.idPedido) {
          pedidoId = item.idPedido;
        }
      });

      EncomendaResource.cancelarEncomendas({
          pedidoId: pedidoId
        }, {
          codigosRastreamento: codigosRastreamento,
          motivo: "Pedido cancelado a pedido do cliente"
        }).$promise
        .then(function(data) {
          // Processa a resposta de cancelamento
          var resultado = {
            sucesso: data.status === 'SUCESSO',
            parcial: data.status === 'PARCIAL',
            falha: data.status === 'FALHA',
            mensagem: data.mensagem,
            remessasCanceladas: data.remessasCanceladas || [],
            erros: data.erros || []
          };
          deferred.resolve(resultado);
          return cb(resultado);
        }).
      catch(function(err) {
        // Extrai a mensagem de erro do backend
        var mensagemErro = 'Erro ao cancelar encomendas';
        if (err.data && err.data.mensagem) {
          mensagemErro = err.data.mensagem;
        } else if (err.data && err.data.message) {
          mensagemErro = err.data.message;
        } else if (err.message) {
          mensagemErro = err.message;
        }

        var resultado = {
          sucesso: false,
          mensagem: mensagemErro,
          erros: []
        };
        deferred.reject(resultado);
        return cb(resultado);
      }.bind(this));

      return deferred.promise;
    };

    Encomenda.verificarArea = function(cep, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      AreaResource.verificarArea({
          cep: cep
        }).$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        }).
      catch(function(err) {
        deferred.reject(err);
        return cb(err);
      }.bind(this));

      return deferred.promise;
    };

    /* END POINTS novos */

    Encomenda.getPackages = function(providerName, filter, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.getPackages({
          provider: providerName,
          canal: filter ? filter.channel : null,
          dataEmissaoFinal: filter ? filter.date.endDate._d.yyyymmdd() : null,
          dataEmissaoInicio: filter ? filter.date.startDate._d.yyyymmdd() : null
        })
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    Encomenda.savePackages = function(providerName, packages, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.savePackages({
          provider: providerName
        }, packages)
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    Encomenda.buscarHorariosAgendamentoColeta = function(dataAtual, userId, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.buscarHorariosAgendamentoColeta({ dataAtual : dataAtual, paraUsuario : userId })
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    Encomenda.agendarColeta = function (pedidoId, numeroOS, dataHoraAgendamentoColetaAntiga, dataHoraAgendamentoColeta, dataHoraAgendamentoColetaLimite, callback) {
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.agendarColeta({ pedidoId: pedidoId }, {
        origem: 'webapp',
        numeroOs: numeroOS,
        antiga: (dataHoraAgendamentoColetaAntiga != null) ? dataHoraAgendamentoColetaAntiga + '-' + $rootScope.GMT : dataHoraAgendamentoColeta + '-' + $rootScope.GMT,
        nova: dataHoraAgendamentoColeta + '-' + $rootScope.GMT,
        dataHoraAgendamentoColeta: dataHoraAgendamentoColeta,
        dataHoraAgendamentoColetaLimite: dataHoraAgendamentoColetaLimite
      })
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    Encomenda.cancelarColeta = function(pedidoId, numeroOS) {
      return EncomendaResource.cancelarColeta({pedidoId: pedidoId}, {
        origem: 'webapp',
        numeroOs: numeroOS
      }).$promise;
    };

    Encomenda.podeMudarAgendamento = function(pedidoId, callback){
      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.podeMudarAgendamento({pedidoId: pedidoId})
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    }

    Encomenda.podeBloquear = function(encomendaId, callback) {

      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.podeBloquear({
        encomendaId: encomendaId
      })
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    Encomenda.bloquear = function(encomendaId, nomeSolicitante, motivo, callback) {

      var cb = callback || angular.noop;
      var deferred = $q.defer();

      EncomendaResource.bloquear({
        encomendaId: encomendaId
      }, {
        motivo: motivo,
        nomeSolicitante: nomeSolicitante
      })
        .$promise
        .then(function(data) {
          deferred.resolve(data);
          return cb(data);
        })
        .catch(function(err) {
          deferred.reject(err);
          return cb(err);
        }.bind(this));

      return deferred.promise;
    };

    return Encomenda;

  }

  angular.module('mandaeApp')
    .factory('Encomenda', Encomenda);

})();
